"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
  * Basic placeholder based formatting like C# string.Format
  * ('{0} says {1}','la','ba' ) => 'la says ba'
  */
function format(str) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return str.replace(/{(\d+)}/g, function (m, i) {
        return args[i] !== undefined ? args[i].toString() : m;
    });
}
exports.format = format;
function localize(key, str) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    return format.apply(void 0, [str].concat(args));
}
exports.localize = localize;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/monaco/languages/json/core/localize.js
 ** module id = 85
 ** module chunks = 0
 **/